module.exports = __webpack_public_path__ + "static/click_heatmap_dashboard-8430a486f4fed80da634ca164ea745c0.jpg";